(() => {
  /**
   * Uses Swiper package to create a carousel
   * More info: https://swiperjs.com/
   */
  if (customElements.get('boxes-carousel')) {
    return;
  }

  class BoxesCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('[data-arrow-prev]'),
          nextEl: this.querySelector('[data-arrow-next]'),
        },
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: this.hasAttribute('data-secondary') ? 3 : 1,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: this.hasAttribute('data-secondary') ? 3 : 2,
            spaceBetween: 10,
          },
        },
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.options);
    }
  }

  customElements.define('boxes-carousel', BoxesCarousel);
})();
